import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { UploadZipService } from '../../services/upload-zip.service';
import { OrganisationSettingsService } from '../../services/organisation-settings.service';
import { SiteService } from '../../services/context-discovery/site.service';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { CdtStatus } from '../../../cdt-status';
import { LaunchDarklyService } from '../../../../context-discovery-services/services/launch-darkly.service';
import { FeatureFlags } from '../../../../context-discovery-services/constants/feature-flags.const';
import { StatusResolver } from '../../../../context-discovery-services/util';
import { Language } from '../../../../context-discovery-services/models/language.model';
import * as _ from 'lodash';

@Component({
  selector: 'adminapp-upload-zip',
  templateUrl: './upload-zip.component.html',
  styleUrls: ['./upload-zip.component.scss']
})
export class UploadZipComponent implements OnInit, OnDestroy {
  loadingSettings = false;
  loadingContent = false;
  loadingKeymapConfigurations = false;
  zip1Uploaded = false;
  zip1Choosen = false;
  selectFile;
  file: File;
  fileChoosenForLanguageSelection: File;
  unitType = ['Metric', 'Imperial'];
  preChangeZip1: Function;
  preChangeKeymapFile: Function;
  zipContent: Array<any> = [];
  uploadZip1Subscription: Subscription;
  uploadFileDisabled: boolean;
  keymapFileChoosen: boolean = false;
  keymapFileUploaded: boolean = false;
  keymapFile: File;
  selectKeymapFile;

  organisationId = null;
  EbiSystemNumber = null;
  EbiSystemNumberIsEmpty = false;
  UnitType = 'Metric';
  configuredCDTLanguageCodes: Array<String> = null;
  masterListOfCDTLanguages: Array<Language> = null;

  isUnifiedFlowEnabled: boolean;
  isCORToolAccessEnabled: boolean;
  isCDTLanguageFeatureEnabled: boolean;

  organisationSettings = null;

  modalForUpload;
  modalForGoToReUpload;
  isActiveReUploadForKeymapFile: boolean = false;
  isAutomaticAnalyticsSetupFeatureEnabled: boolean;
  isHistoryPublishFeatureEnabled: boolean;
  canUserUploadKeymapFile: boolean;
  launchDarklySubscription: any;
  statusResolver: StatusResolver;

  dmsPortalUrl = null;
  CORToolUrl = environment.CORToolUrl;
  csvFileTypes = [
    'text/comma-separated-values',
    'text/csv',
    'application/csv',
    'application/excel',
    'application/vnd.ms-excel',
    'application/vnd.msexcel',
    'text/anytext'
  ];

  @Output() next = new EventEmitter<boolean>();
  @ViewChild('declarativeSelect') selectElem: ElementRef;
  @ViewChild('ebiSystemInput') ebiSystemNumberInput: ElementRef;
  @ViewChild('languageSelector') languageSelector;
  @ViewChild('cdtLanguageSelectionDialog') cdtLanguageSelectionDialog;
  constructor(
    private uploadService: UploadZipService,
    private settingsService: OrganisationSettingsService,
    private siteService: SiteService,
    private changeDetectorRef: ChangeDetectorRef,
    private ldService: LaunchDarklyService) {
    this.statusResolver = new StatusResolver();
    this.organisationId = sessionStorage.getItem('organizationid');
    this.dmsPortalUrl = environment.dmsPortalUrl;
    this.settingsService.setOrganisationId(this.organisationId);
    const that = this;

    this.preChangeZip1 = function () {
      if (that.zip1Uploaded) {
        that.isActiveReUploadForKeymapFile = false;
        that.open(that.modalForGoToReUpload);
        return false;
      }
      return true;
    };
    this.preChangeKeymapFile = function () {
      if (that.keymapFileUploaded) {
        that.isActiveReUploadForKeymapFile = true;
        that.open(that.modalForGoToReUpload);
        return false;
      }
      return true;
    };

    this.isAutomaticAnalyticsSetupFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.AUTOMATIC_ANALYTICS_SETUP);
    this.isHistoryPublishFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_HISTORY_DATA);
    this.canUserUploadKeymapFile = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.IMPROVED_CONTEXT_DISCOVERY_ACCURACY);
    this.isUnifiedFlowEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.UNIFIED_WORKFLOW);
    this.isCORToolAccessEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.COR_TOOL_ACCESS);
    let responseOnCDTLanguageFeature = this.ldService.getJsonFeatureFlagValue(FeatureFlags.CDT_LANGUAGE_CONFIGURATION);
    this.isCDTLanguageFeatureEnabled = responseOnCDTLanguageFeature.enabled;
    this.masterListOfCDTLanguages = responseOnCDTLanguageFeature.value ? responseOnCDTLanguageFeature.value.map(this.mapToLanguage) : null;
    this.launchDarklySubscription = this.ldService.flagChange.subscribe(_ => {
      this.isAutomaticAnalyticsSetupFeatureEnabled
        = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.AUTOMATIC_ANALYTICS_SETUP, true);
      this.isHistoryPublishFeatureEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_HISTORY_DATA, true);
      this.canUserUploadKeymapFile = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.IMPROVED_CONTEXT_DISCOVERY_ACCURACY, true);
      this.isUnifiedFlowEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.UNIFIED_WORKFLOW, true);
      this.isCORToolAccessEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.COR_TOOL_ACCESS, true);
      responseOnCDTLanguageFeature = this.ldService.getJsonFeatureFlagValue(FeatureFlags.CDT_LANGUAGE_CONFIGURATION, true);
      this.isCDTLanguageFeatureEnabled = responseOnCDTLanguageFeature.enabled;
      this.masterListOfCDTLanguages
        = responseOnCDTLanguageFeature.value ? responseOnCDTLanguageFeature.value.map(this.mapToLanguage) : null;
    });
  }

  private mapToLanguage(rawData: any) {
    const language = new Language();
    language.languageCode = rawData.LanguageCode;
    language.languageText = rawData.LanguageText;
    return language;
  }

  isKeymapFileModalAllowedToReUpload(): boolean {
    return this.canUserUploadKeymapFile && this.isActiveReUploadForKeymapFile;
  }

  open(element) {
    if (element && element.open) {
      element.open();
    }
  }
  close(element) {
    if (element && element.close) {
      element.close();
    }
  }

  unitTypeChanged(event) {
    if (!this.isUnifiedFlowEnabled) {
      this.UnitType = event.detail.value ? event.detail.value : this.unitType[0];
    }
  }
  ebiSystemNumberChanged(event) {
    if (!this.isUnifiedFlowEnabled) {
      this.EbiSystemNumber = event.detail.value ? event.detail.value : '';
    }
  }

  ngOnInit() {
    this.modalForUpload = document.querySelector('#actions');
    this.modalForGoToReUpload = document.querySelector('#modalForGoToReUpload');

    this.loadingContent = true;
    this.loadingSettings = true;
    this.settingsService.getSettings().subscribe(settings => {
      this.organisationSettings = settings;

      if (this.canUserUploadKeymapFile) {
        this.loadingKeymapConfigurations = true;
        const modelId = this.getModelIdFromOrganizationSettings();
        if (modelId) {
          this.siteService.getUploadedKeymapFileName(modelId).subscribe(keymapData => {
            this.selectKeymapFile = (<any>keymapData).fileName;
            this.keymapFileUploaded = this.selectKeymapFile;
          }, _ => {
            this.keymapFileUploaded = false;
          }, () => {
            this.loadingKeymapConfigurations = false;
          });
        } else {
          this.keymapFileUploaded = false;
          this.loadingKeymapConfigurations = false;
        }
      }

      if (this.organisationSettings && this.organisationSettings.PreSales) {
        this.UnitType = this.organisationSettings.General.UnitType ? this.organisationSettings.General.UnitType : this.unitType[0];
        this.configuredCDTLanguageCodes = (this.isCDTLanguageFeatureEnabled && this.organisationSettings.PreSales.CdtLanguages)
          ? this.organisationSettings.PreSales.CdtLanguages : null;
      }
      this.uploadService.getZipContent().subscribe(
        zipData => {
          this.selectFile = (<any>zipData).FileName;
          this.zip1Uploaded = true;
          this.applyZipContent(zipData);

          this.loadingContent = false;
        },
        _ => {
          this.loadingContent = false;
          this.zip1Uploaded = false;
        });
      this.loadingSettings = false;
    }, (error) => {
      console.log(error);
      this.loadingSettings = false;
    });

    this.siteService.getStatusFromOrganizationIdWithCache(this.organisationId).subscribe(statusResponse => {
      if (statusResponse) {
        this.uploadFileDisabled = false;

        if (statusResponse.Status === CdtStatus.IN_PROGRESS
          || this.statusResolver.getStatusOfPublishWithAutomaticAnalyticsSetup(
            this.statusResolver.getCompleteOnboardingStatus(statusResponse, this.isAutomaticAnalyticsSetupFeatureEnabled),
            this.isAutomaticAnalyticsSetupFeatureEnabled) === CdtStatus.PUBLISH_IN_PROGRESS
          || (this.isHistoryPublishFeatureEnabled &&
            this.statusResolver.getStatusOfPublishHistory(statusResponse) === CdtStatus.PUBLISH_IN_PROGRESS)) {
          this.uploadFileDisabled = true;
        }
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  onUploadZip1() {
    this.zip1Uploaded = false;
    this.uploadZip1Subscription = this.uploadService.uploadZip(this.file).subscribe(_ => {
      this.zip1Uploaded = true;
      this.close(this.modalForUpload);
      this.loadingContent = true;
      this.uploadZip1Subscription = null;
      this.uploadService.getZipContent().subscribe(zipData => {
        this.applyZipContent(zipData);
        this.loadingContent = false;
      }, this.handleFailure.bind(this));
      if (!this.organisationSettings.PreSales) { this.organisationSettings.PreSales = {}; }
      if (!this.organisationSettings.General) { this.organisationSettings.General = {}; }
      this.organisationSettings.PreSales.CdtStatus = 'NewFile';
      if (!this.organisationSettings.General.UnitType) {
        this.organisationSettings.General.UnitType = this.UnitType;
      }
      if (this.isCDTLanguageFeatureEnabled && this.configuredCDTLanguageCodes) {
        this.organisationSettings.PreSales.CdtLanguages = this.configuredCDTLanguageCodes;
      }

      this.settingsService.setSettings(this.organisationSettings).subscribe(_ => { }, this.handleFailure.bind(this));
    },
      this.handleFailure.bind(this));
  }

  applyZipContent(zipData) {
    this.zipContent = (<any>zipData).FileList;
    const grid = <any>document.querySelector('coretex-grid');

    grid.columns = [
      {
        id: 'Description',
        label: 'Artifacts'
      },
      {
        id: 'Name',
        label: 'File Name'
      },
      {
        id: 'IsAvailable',
        label: 'Availability Status'
      }
    ];

    if (this.zipContent && this.zipContent.length) {
      this.zipContent.forEach(function (element) {
        element.IsAvailable ? element.AvailableTitle = 'Available' : element.AvailableTitle = '';
        element.IsAvailable ? element.UnavailableTitle = '' : element.UnavailableTitle = 'Not Available';
      });
    }

    grid.items = this.zipContent;

    this.EbiSystemNumber = (<any>zipData).EbiId;

    if (!this.EbiSystemNumber) {
      if (this.organisationSettings.PreSales) {
        this.EbiSystemNumber = this.organisationSettings.PreSales.EbiSystemNumber;
      }
      if (!this.EbiSystemNumber) {
        this.EbiSystemNumberIsEmpty = true;
      }
    } else {
      if (!this.organisationSettings.PreSales) { this.organisationSettings.PreSales = {}; }
      this.organisationSettings.PreSales.EbiSystemNumber = this.EbiSystemNumber;
      this.settingsService.setSettings(this.organisationSettings).subscribe(_ => { }, this.handleFailure.bind(this));
    }
  }

  onFileZip1Selected(file: File) {
    if (this.isCDTLanguageFeatureEnabled) {
      this.fileChoosenForLanguageSelection = file;
      this.open(this.cdtLanguageSelectionDialog.languageSelectionDialog.nativeElement);
    } else {
      this.zip1Choosen = true;
      this.file = file;
      this.open(this.modalForUpload);
      this.onUploadZip1();
    }
  }

  onFileZip1SelectedModal($event) {
    if ($event.target.files[0].type === 'application/x-zip-compressed') {
      this.onFileZip1Selected($event.target.files[0]);
    } else {
      this.handleFailure('You can upload only ZIP files!');
    }
  }

  onFileKeymapSelected(file: File) {
    this.keymapFileChoosen = true;
    this.keymapFile = file;
    this.onUploadKeymapFile();
  }

  onFileKeymapSelectedModal($event) {
    if (this.csvFileTypes.includes($event.target.files[0].type)) {
      if (/[^-_.A-Za-z0-9]+/g.test($event.target.files[0].name)) {
        this.handleFailureOnUploadKeymapFile('Upload a valid file of type csv');
      } else {
        this.onFileKeymapSelected($event.target.files[0]);
      }
    } else {
      this.handleFailureOnUploadKeymapFile('You can upload only csv files!');
    }
  }

  getModelIdFromOrganizationSettings(): string {
    if (this.organisationSettings && this.organisationSettings.General && this.organisationSettings.General.ModelIds
      && this.organisationSettings.General.ModelIds.length === 1) {
      return this.organisationSettings.General.ModelIds[0];
    }
    return null;
  }

  onUploadKeymapFile() {
    const modelId = this.getModelIdFromOrganizationSettings();
    if (modelId) {
      this.loadingKeymapConfigurations = true;
      this.siteService.uploadKeymapFile(modelId, this.keymapFile).subscribe(_ => {
        this.showSuccessToastOnUploadKeymapFile(this.keymapFile.name);
        this.keymapFileUploaded = true;

        if (!this.organisationSettings.PreSales) { this.organisationSettings.PreSales = {}; }
        if (this.zip1Uploaded) {
          this.organisationSettings.PreSales.CdtStatus = 'NewFile';
        }

        this.settingsService.setSettings(this.organisationSettings).subscribe(_ => { }, this.handleFailureOnUploadKeymapFile.bind(this));
      }, this.handleFailureOnUploadKeymapFile.bind(this), () => {
        this.onUploadKeymapFileComplete();
      });
    }
  }

  onUploadKeymapFileComplete() {
    this.keymapFileChoosen = false;
    if (this.keymapFile) {
      this.selectKeymapFile = this.keymapFile.name;
    }
    this.keymapFile = null;
    this.loadingKeymapConfigurations = false;
  }

  ngOnDestroy() {
    if (!this.isUnifiedFlowEnabled && this.zip1Uploaded && this.organisationSettings) {
      if (!this.organisationSettings.PreSales) { this.organisationSettings.PreSales = {}; }
      if (!this.organisationSettings.General) { this.organisationSettings.General = {}; }
      this.organisationSettings.PreSales.EbiSystemNumber = this.EbiSystemNumber;
      this.organisationSettings.General.UnitType = this.UnitType;
      this.loadingSettings = true;
      this.settingsService.setSettings(this.organisationSettings).subscribe(() => {
      }, this.handleFailure.bind(this));
    }
  }

  onZip1UploadCancel() {
    this.close(this.modalForUpload);
    if (this.uploadZip1Subscription) {
      this.uploadZip1Subscription.unsubscribe();
      this.uploadZip1Subscription = null;
    }
  }

  handleFailure(errorResponse) {

    const criticalUploadZip: any = document.querySelector('#criticalUploadZip');

    let message;

    if (errorResponse.error === undefined) {
      message = errorResponse;
    } else {
      message = errorResponse.error.Message;
    }

    criticalUploadZip.text = message;
    this.open(criticalUploadZip);

    this.zip1Uploaded = false;
    this.uploadZip1Subscription = null;
    this.close(this.modalForUpload);
    this.loadingContent = false;
    this.loadingSettings = false;

    this.changeDetectorRef.detectChanges();
  }

  handleFailureOnUploadKeymapFile(errorResponse) {
    const criticalUploadKeymapFile: any = document.querySelector('#criticalUploadKeymapFile');

    let message;
    if (errorResponse.error === undefined) {
      message = errorResponse;
    } else if (errorResponse.error.messages) {
      message = errorResponse.error.messages.join('. ');
    } else {
      message = errorResponse.error.Message;
    }
    criticalUploadKeymapFile.text = message;
    this.open(criticalUploadKeymapFile);

    this.keymapFileUploaded = false;
    this.loadingKeymapConfigurations = false;

    this.changeDetectorRef.detectChanges();
  }

  showSuccessToastOnUploadKeymapFile(fileName) {
    const successfulUploadKeymapFile: any = document.querySelector('#successUploadKeymapFile');
    successfulUploadKeymapFile.text = 'Naming conventions file \'' + fileName + '\' is successfully uploaded.';
    this.open(successfulUploadKeymapFile);
  }

  onSave() {
    if (this.zip1Uploaded && this.organisationSettings) {
      if (!this.organisationSettings.PreSales) { this.organisationSettings.PreSales = {}; }
      if (!this.organisationSettings.General) { this.organisationSettings.General = {}; }
      if (this.ebiSystemNumberInput.nativeElement.value) {
        this.EbiSystemNumber = this.ebiSystemNumberInput.nativeElement.value;
      }
      this.organisationSettings.PreSales.EbiSystemNumber = this.EbiSystemNumber;
      if (this.isCDTLanguageFeatureEnabled) {
        this.configuredCDTLanguageCodes = this.languageSelector.getSelectedLanguageCodes();
        this.organisationSettings.PreSales.CdtLanguages = this.configuredCDTLanguageCodes;
      }
      if (this.selectElem.nativeElement.value) {
        this.UnitType = this.selectElem.nativeElement.value;
      }
      this.organisationSettings.General.UnitType = this.UnitType;
      this.loadingSettings = true;
      this.settingsService.setSettings(this.organisationSettings).subscribe(
        this.handleSaveSettingsSuccessCallBack.bind(this),
        this.handleFailure.bind(this));
    }
  }

  handleSaveSettingsSuccessCallBack() {
    this.loadingSettings = false;
    const successfulUploadFile: any = document.querySelector('#successUploadZip');
    successfulUploadFile.text = 'System information saved successfully!';
    this.open(successfulUploadFile);
  }

  hasUnsavedData() {
    if (this.zip1Uploaded && (this.selectElem.nativeElement.value && this.selectElem.nativeElement.value !== this.UnitType) ||
      (this.ebiSystemNumberInput.nativeElement.value && this.EbiSystemNumber !== this.ebiSystemNumberInput.nativeElement.value) ||
      (this.isCDTLanguageFeatureEnabled && this.languageSelector &&
        !_.isEqual(this.languageSelector.getSelectedLanguageCodes(), this.configuredCDTLanguageCodes))) {
      return true;
    }
    return false;
  }

  canDeactivate() {
    if (this.isUnifiedFlowEnabled && this.hasUnsavedData()) {
      if (confirm('You have unsaved changes! If you leave, your changes will be lost.')) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  onLanguageSelectionModalEvents($event) {
    if ($event.success) {
      this.configuredCDTLanguageCodes = $event.data;
      this.zip1Choosen = true;
      this.file = this.fileChoosenForLanguageSelection;
      this.open(this.modalForUpload);
      this.onUploadZip1();
    } else {
      this.handleFailure('Point List Language is not selected during upload! Try again uploading file.');
    }
  }

  onFileModalClick($event) {
    if ($event && $event.target) {
      $event.target.value = '';
    }
  }
}
